import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Card, CardBody, Col, Container, FormFeedback, Input, Modal, Row, } from "reactstrap";
import { Label, FormGroup } from "reactstrap";
import { isAnyValueEmpty } from "../../components/Common/CommonLogic";
import { GET_ROLE_TYPE } from "../../store/Global/actiontype";
import { getAllTenantLocationData, getUsersData } from "../../store/Settings/actions";
import useAddUser from "./hook/useAddUser";
import TopBreadcrumbs from "./Surcharge/TopBreadcrumbs";
import { addUserBreadcrumb, EditUserBreadcrumb } from "../../common/data/parties";
import { optionMarkupType } from "../../common/data/common";
import {accessMarketPlaceRate} from "../../store/layout/actions";
import TourGuide from "../../components/Common/TourGuide/TourGuide";

export default function AddUserData() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { settings_users_data, tenant_all_location_data } = useSelector((state) => state.settings);
    const { roleData } = useSelector((state) => state.globalReducer);
    const navigateState = useLocation();
    const [locations, setLocation] = useState([]);

    useEffect(() => {
        if (roleData?.length === 0 || roleData === undefined) {
            dispatch({ type: GET_ROLE_TYPE });
        }
        dispatch(getAllTenantLocationData())
    }, []);



    useEffect(() => {
        const newLocation = tenant_all_location_data?.content?.map(location => ({
            value: location.id,
            label: location.name,
            id: location.id,
        })) || [];

        const addNewItem = {
            value: 'add_new',
            label: 'Add New',
        };
        console.log(tenant_all_location_data);
        setLocation([...newLocation, addNewItem]);
    }, [tenant_all_location_data]);

    const managerInfo = Array.isArray(settings_users_data.content)
        ? settings_users_data.content.map((user) => ({
            label: `${user.firstName} ${user.lastName}`,
            value: user.id.toString(),
            id: user.id,
            version: user.version,
        })) : [];

    const { initialValues, schema, handleAddUser, handleSwitchChange, switches } = useAddUser(navigateState?.state);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: schema,
        onSubmit: handleAddUser,
    });

    useEffect(() => {
        console.log(formik?.errors)
    }, [formik?.errors])

    return (
        <>
            <div className="page-content">
                <Container fluid>
                    <TourGuide>
                        <div className="main_freight_wrapper">
                            <TopBreadcrumbs breadcrumbs={!!navigateState?.state?.id ? EditUserBreadcrumb : addUserBreadcrumb} tourAdress={"AddUserDetails"} />
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody>
                                            <form>
                                                <div className="row">
                                                    {/* First name */}
                                                    <div className="col-md-6 col-lg-4 mb-4">
                                                        <label className="form-label">First Name<span className='required_star'>*</span></label>
                                                        <div className="">
                                                            <Input
                                                                type="text"
                                                                name="firstName"
                                                                id="firstName"
                                                                value={formik.values.firstName}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                className="form-control"
                                                                placeholder="Enter First Name"
                                                                invalid={formik.touched.firstName && formik.errors.firstName ? true : false}
                                                            />
                                                            {formik.touched.firstName && formik.errors.firstName ? (
                                                                <FormFeedback> {formik.errors.firstName} </FormFeedback>
                                                            ) : null}
                                                        </div>
                                                    </div>

                                                    {/* Last name */}
                                                    <div className="col-md-6 col-lg-4 mb-4">
                                                        <label className="form-label">Last Name</label>
                                                        <div className="">
                                                            <Input
                                                                type="text"
                                                                name="lastName"
                                                                id="lastName"
                                                                value={formik.values.lastName}
                                                                onChange={formik.handleChange}
                                                                className="form-control"
                                                                placeholder="Enter Last Name"
                                                                onBlur={formik.handleBlur}
                                                                invalid={formik.touched.lastName && formik.errors.lastName ? true : false}
                                                            />
                                                            {formik.touched.lastName && formik.errors.lastName ? (
                                                                <FormFeedback> {formik.errors.lastName} </FormFeedback>
                                                            ) : null}
                                                        </div>
                                                    </div>

                                                    {/* Email */}
                                                    <div className="col-md-6 col-lg-4 mb-4">
                                                        <label className="form-label">Email Id<span className='required_star'>*</span></label>
                                                        <div className="">
                                                            <Input
                                                                type="text"
                                                                name="email"
                                                                id="email"
                                                                value={formik.values.email}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                className="form-control"
                                                                placeholder="Enter Email id"
                                                                autoComplete="off"
                                                                invalid={formik.touched.email && formik.errors.email ? true : false}
                                                            />
                                                            {formik.touched.email && formik.errors.email ? (
                                                                <FormFeedback> {formik.errors.email} </FormFeedback>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    {/* Select Role */}
                                                    <div className="col-md-6 col-lg-4 mb-4">
                                                        <label className="form-label">Role<span className='required_star'>*</span></label>
                                                        <div className="">
                                                            <Select
                                                                value={roleData?.filter((role) => formik.values.roles.includes(role.id))}
                                                                onChange={(selectedOptions) => {
                                                                    const selectedValues = selectedOptions.map((option) => option.id);
                                                                    formik.setFieldValue("roles", selectedValues);
                                                                }}
                                                                name="roles"
                                                                id="roles"
                                                                options={roleData}
                                                                onBlur={formik.handleBlur}
                                                                isMulti
                                                                placeholder="Select Role"
                                                                classNamePrefix="select2-selection form-select"
                                                                invalid={formik.touched.roles && formik.errors.roles ? true : false}
                                                            />
                                                            {formik.touched.roles && formik.errors.roles ? (
                                                                <FormFeedback> {formik.errors.roles} </FormFeedback>
                                                            ) : null}
                                                        </div>
                                                    </div>

                                                    {/* Password */}
                                                    {!(!!navigateState?.state?.id) &&
                                                        < div className="col-md-6 col-lg-4 mb-4">
                                                            <label className="form-label">Enter Password<span className='required_star'>*</span></label>
                                                            <div className="">
                                                                <Input
                                                                    type="password"
                                                                    name="password"
                                                                    id="password"
                                                                    value={formik.values.password}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    className="form-control"
                                                                    placeholder="Enter Password"
                                                                    autoComplete="off"
                                                                    invalid={formik.touched.password && formik.errors.password ? true : false}
                                                                />
                                                                {formik.touched.password && formik.errors.password ? (
                                                                    <FormFeedback> {formik.errors.password} </FormFeedback>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    }

                                                    {/* Re-Enter Password */}
                                                    {!(!!navigateState?.state?.id) &&
                                                        <div className="col-md-6 col-lg-4 mb-4">
                                                            <label className="form-label"> Re-Enter Password<span className='required_star'>*</span></label>
                                                            <div className="">
                                                                <Input
                                                                    type="password"
                                                                    name="reEnterdPassword"
                                                                    id="reEnterdPassword"
                                                                    value={formik.values.reEnterdPassword}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    className="form-control"
                                                                    placeholder="Re-Enter Password"
                                                                    invalid={formik.touched.reEnterdPassword && formik.errors.reEnterdPassword ? true : false}
                                                                    autoComplete="off"
                                                                />
                                                                {formik.touched.reEnterdPassword && formik.errors.reEnterdPassword ? (
                                                                    <FormFeedback> {formik.errors.reEnterdPassword} </FormFeedback>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    }

                                                    {/* Manager */}
                                                    <div className="col-md-6 col-lg-3 mb-4">
                                                        <label className="form-label">Manager</label>
                                                        <div className="">
                                                            <Select
                                                                name="manager"
                                                                id="manager"
                                                                value={formik.values.manager}
                                                                onChange={(e) => { formik.setFieldValue("manager", e); }}
                                                                onBlur={formik.handleBlur}
                                                                options={managerInfo}
                                                                placeholder="Select Employee"
                                                                classNamePrefix="select2-selection form-select"
                                                                invalid={formik.touched.manager && formik.errors.manager ? true : false}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Location */}
                                                    <div className="col-md-6 col-lg-3 mb-4">
                                                        <label className="form-label">Location</label>
                                                        <div className="">
                                                            <Select
                                                                name="location"
                                                                id="location"
                                                                value={locations ? locations.find((option) => option.value === formik.values.location) || "" : ""}
                                                                onChange={(e) => {
                                                                    if (e.label == "Add New") {
                                                                        navigate("/Settings/AddTanentLocation")
                                                                    } else {
                                                                        formik.setFieldValue("location", e.value);
                                                                    }
                                                                }}
                                                                onBlur={formik.handleBlur}
                                                                options={locations}
                                                                placeholder={"Select locations"}
                                                                classNamePrefix="select2-selection form-select"
                                                                invalid={formik.touched.location && formik.errors.location ? true : false}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className=" row col-md-6 col-lg-3 mb-4">
                                                        <label className="form-label">  Purview Type <span className='required_star'>*</span></label>
                                                        <div >
                                                            <Select
                                                                value={optionMarkupType && optionMarkupType.find(obj => obj.value === formik.values.purviewType)}
                                                                name='purviewType'
                                                                onChange={(e) => { formik.setFieldValue("purviewType", e.value); }}
                                                                options={optionMarkupType}
                                                                isDisabled={roleData?.filter(data => data.value === "PRICING_TEAM" || data.value === "TENANT_SALES_MANAGER").some(role => formik.values.roles.includes(role.id))}
                                                                classNamePrefix="select2-selection form-select"
                                                                menuPlacement="auto"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row col-md-6 col-lg-3 mb-4">
                                                        <label className="form-label"> Discount <span className='required_star'>*</span></label>
                                                        <div >
                                                            <Input
                                                                type="number"
                                                                name="discountPurview"
                                                                id="discountPurview"
                                                                value={formik.values.discountPurview}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                isDisabled={roleData?.filter(data => data.value === "PRICING_TEAM" || data.value === "TENANT_SALES_MANAGER").some(role => formik.values.roles.includes(role.id))}
                                                                className="form-control"
                                                                placeholder="Enter Discout "
                                                                invalid={formik.touched.discountPurview && formik.errors.discountPurview ? true : false}
                                                            />
                                                            {formik.touched.discountPurview && formik.errors.discountPurview ? (
                                                                <FormFeedback> {formik.errors.discountPurview} </FormFeedback>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*<div className="row">
                                                <div className="col-md-6 col-lg-12 mb-4">
                                                    <label className="form-label">Instant Rate Preferred Landing Page <span className='required_star'>*</span></label>
                                                    <div className="row">
                                                        <div className="row col-md-6 col-lg-3 mb-4">
                                                            <h5 className="align-content-center"><label className="form-label">Domestics</label></h5>
                                                        </div>
                                                        <div className="row col-md-6 col-lg-3 mb-4">
                                                            <div className="d-flex gap-4 align-items-center">
                                                                <div className="d-flex flex-column align-items-center">
                                                                    <label className="form-label"><span className="mb-2">Air Cargo</span></label>
                                                                    <div className="square-switch">
                                                                        <Input type="checkbox"
                                                                               id="domestic-air-cargo"
                                                                               switch="none"
                                                                               role="switch"
                                                                               checked={switches["domestic-air-cargo"]}
                                                                               onClick={() => {
                                                                                   handleSwitchChange("domestic-air-cargo")
                                                                               }}
                                                                        />
                                                                        <Label htmlFor="domestic-air-cargo" data-on-label="Yes"
                                                                               data-off-label="No"></Label>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="row col-md-6 col-lg-3 mb-4">
                                                            <h5 className="align-content-center"><label className="form-label">International</label></h5>
                                                        </div>
                                                        <div className="row col-md-6 col-lg-3 mb-4">
                                                            <div className="d-flex gap-4 align-items-center">
                                                                <div className="d-flex flex-column align-items-center">
                                                                    <label className="form-label"><span className="mb-2">LCL</span></label>
                                                                    <div className="square-switch">
                                                                        <Input type="checkbox"
                                                                               id="inter-lcl"
                                                                               switch="none"
                                                                               role="switch"
                                                                               checked={switches["inter-lcl"]}
                                                                               onClick={() => handleSwitchChange("inter-lcl")}
                                                                        />
                                                                        <Label htmlFor="inter-lcl" data-on-label="Yes"
                                                                               data-off-label="No"></Label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row col-md-6 col-lg-3 mb-4">
                                                            <div className="d-flex gap-4 align-items-center">
                                                                <div className="d-flex flex-column align-items-center">
                                                                    <label className="form-label"><span className="mb-2">FCL</span></label>
                                                                    <div className="square-switch">
                                                                        <Input type="checkbox"
                                                                               id="inter-fcl"
                                                                               switch="none"
                                                                               role="switch"
                                                                               checked={switches["inter-fcl"]}
                                                                               onClick={() => handleSwitchChange("inter-fcl")}
                                                                        />
                                                                        <Label htmlFor="inter-fcl" data-on-label="Yes"
                                                                               data-off-label="No"></Label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row col-md-6 col-lg-3 mb-4">
                                                            <div className="d-flex gap-4 align-items-center">
                                                                <div className="d-flex flex-column align-items-center">
                                                                    <label className="form-label"><span className="mb-2">AIR CARGO</span></label>
                                                                    <div className="square-switch">
                                                                        <Input type="checkbox"
                                                                               id="inter-air-cargo"
                                                                               switch="none"
                                                                               role="switch"
                                                                               checked={switches["inter-air-cargo"]}
                                                                               onClick={() => handleSwitchChange("inter-air-cargo")}
                                                                        />
                                                                        <Label htmlFor="inter-air-cargo" data-on-label="Yes"
                                                                               data-off-label="No"></Label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>*/}

                                                <div className="row">
                                                    <div className="d-flex justify-content-center">
                                                        <div id="submitAddUser" className="mb-3 mx-3 d-flex justify-content-end">
                                                            <button className=" btn btn-primary"  type="submit" onClick={formik.handleSubmit} > Save </button>
                                                        </div>
                                                        <div className="mb-3 mx-3 d-flex justify-content-end">
                                                            <button className=" btn btn-primary" type="button" onClick={() => { formik.resetForm();  navigate(-1); }}>Cancel</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </TourGuide>
                </Container >
            </div >

            {/* modal */}
            {/* <Modal
                isOpen={openSaveModal}
                toggle={() => { setOpenSaveModal(!openSaveModal); }}
                className='confirm_modal_wrap'
            >
                <div className="modal-header">
                    <button
                        type="button"
                        onClick={() => { setOpenSaveModal(false); }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body pb-5">
                    <h4 className='text-center'>Are you sure?</h4>
                </div>
                <div className="modal-footer justify-content-center">
                    <button
                        type="button"
                        onClick={() => {
                            setOpenSaveModal(!openSaveModal);
                        }}
                        className="btn btn-secondary "
                        data-dismiss="modal"
                    >
                        Cancel
                    </button>
                    <button type="button" onClick={() => { setFinalSaveButton(true); }} className="btn btn-primary ">
                        Save changes
                    </button>
                </div>
            </Modal> */}
        </>
    );
}
